// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__T1aWy","Cancel":"schedule_Cancel__QCamM"};